import {StoreExt} from '@utils/reactExt'
import {observable, action, runInAction} from 'mobx'
import {userStore} from '@store/userStore'
import {deepClone} from '@src/utils';
import {GOODS_TYPE_V} from '@src/constants';
import MultiActivity from '@utils/multiActivity';

class PackageUpgradeStore extends StoreExt {
    @observable currentSelectedPackageDto: any = {};  // 当前选择的要升级的套餐
    @observable currentSelectedServicePackageDto: any = {};  // 当前选择的升级包
    @observable effectiveNow: '1' | '0' = '1';  // 当月是否生效
    @observable availableUpgradeList: any[] = [];  // 可升级套餐
    @observable serviceGoodsList: any[] = []; // 升级包列表
    @observable costInfo: any = {}; // 价格信息
    @observable currentSelectActIds: string[] = []; // 选择的活动
    @observable changeRule: any = {}; // 升级进度信息
    @observable availableReceiveCouponList: any[] = []; // 可领取优惠券
    @observable currentSelectId: string; // 当前选中的服务商品

    @action
    clearData = () => {
        this.currentSelectedPackageDto = {};
        this.currentSelectedServicePackageDto = {};
        this.effectiveNow = '1';
        this.availableUpgradeList = [];
        this.serviceGoodsList = [];
        this.costInfo = {};
        this.currentSelectActIds = [];
        this.changeRule = {}
        this.currentSelectId = ''
    };
    @action
    setObservableData = (key, value) => {
        runInAction(() => {
            this[key] = value
        })
    };
    /**
     * 套餐详情页查询可领取优惠券
     * @param {string} goodsReleaseId
     * @returns {Promise<void>}
     */
    @action
    getCouponList = async (goodsReleaseId: string) => {
        let availableReceiveCouponList = [];
        try {
            availableReceiveCouponList = await this.api.queryCouponList({goodsReleaseId, iccid: userStore.currentDeviceInfo.simId});
        } catch (e) {
            availableReceiveCouponList = []
        } finally {
            runInAction(() => this.availableReceiveCouponList = availableReceiveCouponList)
        }
    };
    /**
     * 领券
     * @param {string} activityId
     * @param {string} discountId
     * @param {() => void} callback
     * @returns {Promise<void>}
     */
    @action
    receiveCoupon = async (activityId: string, discountId?: string, callback?: () => void) => {
        try {
            await this.api.receiveCoupons({
                activityId: activityId,
                discountId: discountId
            });
            this.$toast.info('领取成功', 1);
            if (callback) {
                callback()
            }
        } catch (e) {
            console.error(e)
        }
    }

    @action
    queryUnityPlanDetail = async (goodsReleaseId: string, elementId: string) => {
        try {
            const res = await this.api.queryUnityPlanDetail({goodsReleaseId, elementId, page: '1'});
            res.infoLists = !!res.productInfo ? res.productInfo.split('\n') : [];
            this.setObservableData('currentSelectedServicePackageDto', res)
        } catch (e) {
        }
    };
    // 查询可升级套餐
    @action
    queryAvailableUpgradePackage = async () => {
        try {
            const res = await this.api.queryUserGoodsChange({});
            const availableUpgradeList = res.filter(item => item.allowUpgrade === '1');
            this.setObservableData('availableUpgradeList', availableUpgradeList);
        } catch (e) {
            console.error(e)
        }
    };
    /**
     * 查询升级包
     * @param {string} userGoodsId
     * @returns {Promise<void>}
     */
    @action
    queryServiceGoods = async (userGoodsId: string) => {
        try {
            const res = await this.api.queryService({userGoodsId});
            res.map(item => {
                item.infoLists = !!item.productInfo ? item.productInfo.split('\n') : []
            });
            this.setObservableData('serviceGoodsList', res);
        } catch (e) {
        }
    };

    /**
     * 计算价格
     * @param {any} serviceGoodsId
     * @param {any} userGoodsId
     * @param {any} effectiveNow
     * @param {any} activityIds
     * @returns {Promise<void>}
     */
    @action
    calculateUpgradeCost = async ({serviceGoodsId, userGoodsId, effectiveNow, activityIds}) => {
        try {
            const res = await this.api.caculateUpgradeCost({serviceGoodsId, userGoodsId, effectiveNow, activityIds});
            this.setObservableData('changeRule', res.changeRule);
            this.setObservableData('costInfo', res);
        } catch (e) {
        }
    };
    /**
     * 生成升级订单
     * @param value
     * @returns {Promise<void>}
     */
    @action
    generateUpgradeOrder = async value => {
        try {

            this.$toast.loading('订单生成中');
            const currentSelectedPackageDto = deepClone(this.currentSelectedPackageDto);
            const currentSelectedServicePackageDto = deepClone(this.currentSelectedServicePackageDto);
            const allowUseCoupon = this.currentSelectActIds.includes('-1');
            const multiActivity = new MultiActivity(currentSelectedServicePackageDto)
            const res = await this.api.upgradePlan({
                userGoodsId: currentSelectedPackageDto.userGoodsId || userStore.currentDeviceInfo.userGoodsId,
                serviceGoodsId: currentSelectedServicePackageDto.goodsReleaseId,
                paymentType: value[0],
                iccid: userStore.currentDeviceInfo.simId,
                effectiveNow: currentSelectedServicePackageDto.changeRule.effectiveNow === '1' ? this.effectiveNow : '0',
                activityIds: this.currentSelectActIds.toString()
            });
            localStorage.setItem('H5_URL_ORIGIN', JSON.stringify('ordering-upgrade'))
            this.goToPath(`/app/ordering/payorder/paying/${res}/${value[0]}/1/${allowUseCoupon || multiActivity.canUseCoupon()}/${GOODS_TYPE_V.SHENGJI}`);
        } catch (e) {
        }
    }
}

const packageUpgradeStore = new PackageUpgradeStore();
export {packageUpgradeStore, PackageUpgradeStore}
